(() => {
  'use strict';

  if (window.__tichoVariantGalleryLoaded) return;
  window.__tichoVariantGalleryLoaded = true;

  const SKU_REGEX = /SL\d{4}/i;

  function getImageText(element) {
    if (!element) return '';

    const values = [];

    element.querySelectorAll('img, source').forEach((node) => {
      ['src', 'srcset', 'data-src', 'data-srcset'].forEach((attr) => {
        const value = node.getAttribute(attr);

        if (value) {
          values.push(value);
        }
      });

      if (node.currentSrc) {
        values.push(node.currentSrc);
      }
    });

    return values.join(' ');
  }

  function getSkuFromMedia(element) {
    const text = getImageText(element);
    const match = text.match(SKU_REGEX);

    return match ? match[0].toUpperCase() : '';
  }

  function getVariantData(gallery) {
    const json = gallery.querySelector(
      '[data-ticho-variant-gallery-data]'
    );

    if (!json) return null;

    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      console.warn('TICHO: błąd danych wariantów', error);
      return null;
    }
  }

  function getCurrentVariantId(gallery, data) {
    const section =
      gallery.closest('.shopify-section') ||
      gallery.parentElement ||
      document;

    const input = section.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (input && input.value) {
      return String(input.value);
    }

    const urlVariant = new URL(window.location.href)
      .searchParams
      .get('variant');

    if (urlVariant) {
      return String(urlVariant);
    }

    return data?.selectedVariantId
      ? String(data.selectedVariantId)
      : '';
  }

  function getCurrentSku(gallery, data) {
    const variantId = getCurrentVariantId(gallery, data);

    const variant = data.variants.find(
      (variant) => String(variant.id) === String(variantId)
    );

    return variant?.sku
      ? variant.sku.toUpperCase()
      : '';
  }

  function getGalleryItems(gallery) {
    const list = gallery.querySelector(
      '[id^="Slider-Gallery-"]'
    );

    if (!list) return [];

    return Array.from(
      list.querySelectorAll(':scope > li[data-media-id]')
    );
  }

  function getThumbnailItems(gallery) {
    const list = gallery.querySelector(
      '[id^="Slider-Thumbnails-"]'
    );

    if (!list) return [];

    return Array.from(
      list.querySelectorAll(':scope > li[data-target]')
    );
  }

  function belongsToSku(element, sku) {
    const mediaSku = getSkuFromMedia(element);

    // Obraz bez SKU traktujemy jako wspólny.
    if (!mediaSku) {
      return true;
    }

    return mediaSku === sku;
  }

  function setVisible(element, visible) {
    element.hidden = !visible;
    element.style.display = visible ? '' : 'none';
    element.setAttribute(
      'aria-hidden',
      visible ? 'false' : 'true'
    );
  }

  function findMainImage(items, sku) {
    const visible = items.filter(
      (item) => !item.hidden
    );

    const main = visible.find((item) => {
      const text = getImageText(item);

      return new RegExp(
        `${sku}[_-]01(?:\\D|$)`,
        'i'
      ).test(text);
    });

    return main || visible[0] || null;
  }

  function updateCounter(gallery, count) {
    const total = gallery.querySelector(
      '.slider-counter--total'
    );

    const current = gallery.querySelector(
      '.slider-counter--current'
    );

    if (total) {
      total.textContent = String(count);
    }

    if (current) {
      current.textContent = '1';
    }
  }

  function updateDayEvening(gallery, items, sku) {
    const findShot = (number) => {
      return items.find((item) => {
        if (item.hidden) return false;

        const text = getImageText(item);

        return new RegExp(
          `${sku}[_-]0?${number}(?:\\D|$)`,
          'i'
        ).test(text);
      });
    };

    const day = findShot(1);
    const evening = findShot(2);

    if (day?.dataset.mediaId) {
      gallery.dataset.tichoDayMedia =
        day.dataset.mediaId;
    }

    if (evening?.dataset.mediaId) {
      gallery.dataset.tichoEveningMedia =
        evening.dataset.mediaId;
    }
  }

  function activateFirstImage(gallery, item) {
    if (!item) return;

    const mediaId = item.dataset.mediaId;

    if (!mediaId) return;

    gallery
      .querySelectorAll('.product__media-item.is-active')
      .forEach((element) => {
        element.classList.remove('is-active');
      });

    item.classList.add('is-active');

    gallery
      .querySelectorAll('.thumbnail[aria-current="true"]')
      .forEach((button) => {
        button.removeAttribute('aria-current');
      });

    const thumbnail = gallery.querySelector(
      `[data-target="${CSS.escape(mediaId)}"] .thumbnail`
    );

    if (thumbnail) {
      thumbnail.setAttribute(
        'aria-current',
        'true'
      );
    }

    if (
      typeof gallery.setActiveMedia === 'function'
    ) {
      try {
        gallery.setActiveMedia(
          mediaId,
          false
        );
      } catch (error) {
        console.log(
          'TICHO: setActiveMedia fallback'
        );
      }
    }
  }

  function filterGallery(gallery) {
    const data = getVariantData(gallery);

    if (!data) return;

    const sku = getCurrentSku(
      gallery,
      data
    );

    if (!sku || !SKU_REGEX.test(sku)) {
      return;
    }

    const items = getGalleryItems(gallery);
    const thumbnails =
      getThumbnailItems(gallery);

    items.forEach((item) => {
      setVisible(
        item,
        belongsToSku(item, sku)
      );
    });

    thumbnails.forEach((item) => {
      setVisible(
        item,
        belongsToSku(item, sku)
      );
    });

    const visibleItems = items.filter(
      (item) => !item.hidden
    );

    updateCounter(
      gallery,
      visibleItems.length
    );

    updateDayEvening(
      gallery,
      items,
      sku
    );

    const firstImage =
      findMainImage(items, sku);

    activateFirstImage(
      gallery,
      firstImage
    );

    gallery.dataset.tichoActiveSku =
      sku;

    console.log(
      `TICHO gallery: ${sku} → ${visibleItems.length} zdjęć`
    );
  }

  function scheduleFilter(gallery) {
    [
      0,
      50,
      150,
      300
    ].forEach((delay) => {
      setTimeout(() => {
        filterGallery(gallery);
      }, delay);
    });
  }

  function initGallery(gallery) {
    if (
      gallery.dataset
        .tichoGalleryInitialized === 'true'
    ) {
      return;
    }

    gallery.dataset
      .tichoGalleryInitialized = 'true';

    scheduleFilter(gallery);

    const section =
      gallery.closest('.shopify-section') ||
      document;

    section.addEventListener(
      'change',
      () => {
        scheduleFilter(gallery);
      }
    );

    section.addEventListener(
      'input',
      () => {
        scheduleFilter(gallery);
      }
    );

    [
      'variant:change',
      'variant-change',
      'product:variant-change'
    ].forEach((eventName) => {
      section.addEventListener(
        eventName,
        () => {
          scheduleFilter(gallery);
        }
      );
    });
  }

  function initAllGalleries() {
    document
      .querySelectorAll('media-gallery')
      .forEach((gallery) => {
        if (
          gallery.querySelector(
            '[data-ticho-variant-gallery-data]'
          )
        ) {
          initGallery(gallery);
        }
      });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAllGalleries
    );
  } else {
    initAllGalleries();
  }

  document.addEventListener(
    'shopify:section:load',
    initAllGalleries
  );

  try {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !==
        'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      subscribe(
        PUB_SUB_EVENTS.variantChange,
        () => {
          document
            .querySelectorAll(
              'media-gallery'
            )
            .forEach((gallery) => {
              scheduleFilter(gallery);
            });
        }
      );
    }
  } catch (error) {
    // Starsza wersja motywu —
    // event change wystarczy.
  }
})();